export interface ImgOrVideoResolution {
  w: number;
  h: number;
}

export function getImageResolution(imgFile: File): Promise<ImgOrVideoResolution> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(imgFile);

    img.onload = () => {
      const result = { w: img.naturalWidth, h: img.naturalHeight };
      URL.revokeObjectURL(objectUrl);
      resolve(result);
    };
    img.onerror = err => {
      URL.revokeObjectURL(objectUrl);
      reject(err);
    };
    img.src = objectUrl;
  });
}

export function getVideoResolution(videoFile: File): Promise<ImgOrVideoResolution> {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    const objectUrl = URL.createObjectURL(videoFile);

    video.addEventListener("loadedmetadata", () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ w: video.videoWidth, h: video.videoHeight });
    });
    video.addEventListener("error", () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to read video dimensions"));
    });
    video.src = objectUrl;
  });
}

export function getRemoteImageDimensions(imageUrl: string): Promise<ImgOrVideoResolution> {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      resolve({ w: img.naturalWidth, h: img.naturalHeight });
    };
    img.onerror = () => {
      reject(new Error("Failed to load image dimensions"));
    };
    img.src = imageUrl;
  });
}

export function getRemoteVideoDimensions(videoUrl: string): Promise<ImgOrVideoResolution> {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.preload = "metadata";

    const dispose = () => {
      video.removeAttribute("src");
      video.load();
    };

    video.addEventListener(
      "loadedmetadata",
      () => {
        const result = { w: video.videoWidth, h: video.videoHeight };
        dispose();
        resolve(result);
      },
      { once: true }
    );
    video.addEventListener(
      "error",
      () => {
        dispose();
        reject(new Error("Failed to load video dimensions"));
      },
      { once: true }
    );
    video.src = videoUrl;
  });
}
